module.exports = __webpack_public_path__ + "img/causa-reforma.a574dc6a.jpeg";